var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaChannels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 0C0.839467 0 0 0.839465 0 1.875V19.125C0 20.1605 0.839466 21 1.875 21H14.625C15.6605 21 16.5 20.1605 16.5 19.125V11.25C16.5 9.17893 14.8211 7.5 12.75 7.5H10.875C9.83947 7.5 9 6.66053 9 5.625V3.75C9 1.67893 7.32107 0 5.25 0H1.875ZM3.75 13.5C3.75 13.0858 4.08579 12.75 4.5 12.75H12C12.4142 12.75 12.75 13.0858 12.75 13.5C12.75 13.9142 12.4142 14.25 12 14.25H4.5C4.08579 14.25 3.75 13.9142 3.75 13.5ZM4.5 15.75C4.08579 15.75 3.75 16.0858 3.75 16.5C3.75 16.9142 4.08579 17.25 4.5 17.25H8.25C8.66421 17.25 9 16.9142 9 16.5C9 16.0858 8.66421 15.75 8.25 15.75H4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22119 0.315905C10.018 1.23648 10.5 2.43695 10.5 3.75V5.625C10.5 5.83211 10.6679 6 10.875 6H12.75C14.0631 6 15.2635 6.48204 16.1841 7.27881C15.2962 3.87988 12.6201 1.20377 9.22119 0.315905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaChannels);
export default __webpack_public_path__ + "static/media/wa_channels.743ee2b0498ace5848ba88bd17c3ccea.svg";
export { ForwardRef as ReactComponent };